export function fmtDate(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export function fmtDateTime(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short" }) + ", " +
    dt.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true });
}

export function fmtINR(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (isNaN(n)) return v;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
}

export function fmtMoney(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (isNaN(n)) return v;
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
}

export function timeAgo(d) {
  if (!d) return "";
  const diff = Date.now() - new Date(d).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export const STATUS_STYLES = {
  po_created: { label: "PO Created", color: "amber" },
  po_sent: { label: "PO Sent", color: "amber" },
  ack_pending: { label: "Ack Pending", color: "amber" },
  acknowledged: { label: "Acknowledged", color: "blue" },
  manufacturing: { label: "Manufacturing", color: "blue" },
  ready_for_dispatch: { label: "Ready for Dispatch", color: "blue" },
  dispatched: { label: "Dispatched", color: "blue" },
  in_transit: { label: "In Transit", color: "blue" },
  delivered: { label: "Delivered", color: "green" },
  closed: { label: "Closed", color: "green" },
  delayed: { label: "Delayed", color: "red" },
  delivery_date_changed: { label: "Date Changed", color: "amber" },
  modification_requested: { label: "Modification Requested", color: "amber" },
  cancelled: { label: "Cancelled", color: "red" },
};

export const COLOR_CLASSES = {
  green: { badge: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]", dot: "bg-[#22C55E]", text: "text-[#166534]" },
  amber: { badge: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]", dot: "bg-[#F59E0B]", text: "text-[#92400E]" },
  red: { badge: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]", dot: "bg-[#EF4444]", text: "text-[#991B1B]" },
  blue: { badge: "bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]", dot: "bg-[#3B82F6]", text: "text-[#1E40AF]" },
  slate: { badge: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400", text: "text-slate-600" },
};
